import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchPipe'
})
export class SearchPipe implements PipeTransform {
  public transform(values, term: string) {
    if (!term) {
      return values
    } else {
      return values.filter((val) => {
        return JSON.stringify(val).toLowerCase().indexOf(term.toLowerCase()) > -1
      });
    };
  }
}
